import axios, {AxiosError, AxiosRequestConfig} from 'axios';
import {RestApiMethod} from './Api';

const client = axios.create({
  baseURL: '/api',
});

interface IRequestProps {
  url: string;
  method: RestApiMethod;
  params?: Record<string, unknown>;
  additionalParams?: Partial<AxiosRequestConfig>;
  onErrorFunction?: (Error: AxiosError) => any;
}

const requestInternal = (
  url: string,
  method: RestApiMethod,
  params?: Record<string, unknown>,
  additionalParams?: Partial<AxiosRequestConfig>
) => {
  const axiosClient = client;

  switch (method) {
    case RestApiMethod.GET:
      return axiosClient.get(url, {params, ...additionalParams});
    default:
      throw new Error('Runtime error');
  }
};

export const request = (props: IRequestProps) => {
  const {
    url,
    method,
    params,
    additionalParams,
    onErrorFunction = () => {},
  } = props;

  return requestInternal(url, method, params, additionalParams).catch(
    (err: AxiosError) => {
      onErrorFunction(err);
      throw err;
    }
  );
};
